<template>
  <ColorPicker
    v-model="showPicker"
    :appliedColor="props.colorInfo"
    :codeHasChildren="Boolean(props.item.children?.length)"
    @submit="emit('colorChange', $event)"
  >
    <template #trigger>
      <div
        class="code-color-item"
        :class="props.type"
        :title="formatCodePath(props.item.path)"
        @click="showPicker = true"
      >
        <span class="item-name">{{ item.name }}</span>
        <span
          v-if="props.colorInfo"
          class="color-indicator"
          :style="{ backgroundColor: props.colorInfo.color }"
        />
      </div>
    </template>
  </ColorPicker>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import ColorPicker
  from '@/ContextTab/modules/news/published/components/colorIndication/ColorPicker.vue'
import { formatCodePath } from '@/lib/codes'
import type { CodeFilterTypes } from '@/ContextTab/modules/news/codes/types'
import type { CodesOfColorsOfDataOfUserProfileGetOut } from '@/api/generated/v1'
import type { AppliedColor }
  from '@/ContextTab/modules/news/published/components/colorIndication/ColorPicker.vue'
import type { CodeWithCategoryAndChildren } from '@/api/generated/v2'


const props = defineProps<{
  item: CodeWithCategoryAndChildren
  type: CodeFilterTypes
  colorInfo?: CodesOfColorsOfDataOfUserProfileGetOut
}>()

const emit = defineEmits<{
  (e: 'colorChange', payload: AppliedColor): void
}>()

const showPicker = ref(false)

</script>

<style scoped>
.code-color-item {
  display: flex;
  align-items: center;
  gap: 8px; /* TODO: replace with token */

  .item-name {
    cursor: pointer;

    &:hover {
      color: #1976d2; /* TODO: replace with token */
    }
  }

  &.feeds {
    flex-direction: row-reverse; /* indicator first */
    align-items: stretch;

    .color-indicator {
      flex: 0 0 5px;
      min-height: 20px;
    }
  }

  &.non-feeds {
    .color-indicator {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
}
</style>
